import { createAction, props } from '@ngrx/store';
import { Attribute, UpdateAttributeRequest } from '@models/attribute.model';

export enum AttributeActions {
  GET_ATTRIBUTES = '[Attributes] Get attributes',
  GET_ATTRIBUTES_SUCCESS = '[Attributes] Attributes fetched',
  GET_ATTRIBUTES_FAILED = '[Attributes] Cannot fetch attributes',
  UPDATE_ATTRIBUTE = '[Attributes] Update attribute',
  UPDATE_ATTRIBUTE_SUCCESS = '[Attributes] Attribute updated',
  UPDATE_ATTRIBUTE_FAILED = '[Attributes] Cannot update attribute',
  CREATE_ATTRIBUTE = '[Attributes] Create attribute',
  CREATE_ATTRIBUTE_SUCCESS = '[Attributes] Attribute created',
  CREATE_ATTRIBUTE_FAILED = '[Attributes] Cannot create attribute',
  DELETE_ATTRIBUTE = '[Attributes] Delete attribute',
  DELETE_ATTRIBUTE_SUCCESS = '[Attributes] Attribute deleted',
  DELETE_ATTRIBUTE_FAILED = '[Attributes] Cannot delete attribute',
  SET_ATTRIBUTE_DETAIL = '[Attributes] Set attribute detail',
}

export const fetchAttributes = createAction(AttributeActions.GET_ATTRIBUTES, props<{ payload: string }>());
export const attributesFetched = createAction(AttributeActions.GET_ATTRIBUTES_SUCCESS, props<{
  payload: Attribute[]
}>());
export const cannotFetchAttributes = createAction(AttributeActions.GET_ATTRIBUTES_FAILED, props<{ error: string }>());
export const updateAttribute = createAction(AttributeActions.UPDATE_ATTRIBUTE, props<{
  payload: UpdateAttributeRequest
}>());
export const attributeUpdated = createAction(AttributeActions.UPDATE_ATTRIBUTE_SUCCESS, props<{
  payload: Attribute
}>());
export const cannotUpdateAttribute = createAction(AttributeActions.UPDATE_ATTRIBUTE_FAILED, props<{ error: string }>());
export const createAttribute = createAction(AttributeActions.CREATE_ATTRIBUTE, props<{
  payload: UpdateAttributeRequest
}>());
export const attributeCreated = createAction(AttributeActions.CREATE_ATTRIBUTE_SUCCESS, props<{
  payload: Attribute
}>());
export const cannotCreateAttribute = createAction(AttributeActions.CREATE_ATTRIBUTE_FAILED, props<{ error: string }>());
export const deleteAttribute = createAction(AttributeActions.DELETE_ATTRIBUTE, props<{
  payload: { webshopId: string, attributeId: string }
}>());
export const attributeDeleted = createAction(AttributeActions.DELETE_ATTRIBUTE_SUCCESS, props<{ payload: string }>());
export const cannotDeleteAttribute = createAction(AttributeActions.DELETE_ATTRIBUTE_FAILED, props<{ error: string }>());

export const setAttributeDetail = createAction(AttributeActions.SET_ATTRIBUTE_DETAIL, props<{ payload?: string }>());
